import { useTenantTranslation } from "hooks/formatters";

import { TableCell, TableHead, TableRow, Typography } from "@mui/material";

import { useCraneDriver } from "../CraneDriverProvider";

export const CraneTableHeader = () => {
  const { assignedLoads: baskets } = useCraneDriver();
  const { t } = useTenantTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 3,
            backgroundColor: "background.paper",
            minWidth: { xs: 56, md: 72, lg: 96 },
            maxWidth: 120,
          }}
        />
        {baskets.map((basket) => (
          <TableCell
            key={basket.load_basket_id}
            align="center"
            sx={{
              fontWeight: "bold",
              padding: { xs: 1, md: 1.5, lg: 2 },
              minWidth: { xs: 280, md: 350, lg: 420 },
              maxWidth: { lg: 500 },
            }}
          >
            {basket.customer_heat_id ? (
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "1.1rem", md: "1.25rem", lg: "1.5rem" },
                }}
              >
                {basket.customer_heat_id}
              </Typography>
            ) : null}
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "1.1rem", md: "1.25rem", lg: "1.5rem" },
              }}
            >
              {t("basket")} {basket.basket_number}
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontSize: { xs: "0.9rem", md: "1rem", lg: "1.1rem" } }}
            >
              {basket.steel_grade_name}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
